// extracted by mini-css-extract-plugin
export default {"card":"xZ-z","carouselContainer":"yZ-z","carouselContent":"zZ-z"};